<template>
  <div>
    <StockPurchaseOrderListReceiving
      :statusId="statusId"
      :pageTitle="pageTitle"
    >
    </StockPurchaseOrderListReceiving>
  </div>
</template>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";

import StockPurchaseOrderListReceiving from "@/modules/stock/components/purchase-orders/StockPurchaseOrderListReceiving.vue";

import AuthService from "@/core/services/auth.service";

import _ from "lodash";
export default {
  name: "StockPurchaseOrderListReceivingPage",
  mixins: [permissionMixin],
  data() {
    return {
      statusId: 4,
      pageTitle: this.$t("LIST_RECEIVING_STOCK_PURCHASE_ORDERS")
    };
  },
  components: { StockPurchaseOrderListReceiving },
  watch: {},
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Receiving Stock Purchase Orders List" }
    ]);

    AuthService.refreshUserData();
  },
  computed: {},
  methods: {}
};
</script>
